export default __webpack_public_path__ + "static/media/deleteIcon.ba60eda6.svg";